import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import BasicSelectField from '../../shared/fields/BasicSelectField';
import { MessageFormat } from '@paypalcorp/worldready';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';

const renderReceivableCurrency = (props) => {
  const options = [...props.receivableCurrency];
  return <BasicSelectField options={options} {...props} />;
};

function Currency({ receivableCurrency, handleAmountFormatChange }) {
  const worldReady = useContext(WorldReadyContext);

  return (
    <Field
      id="receiverCurrency"
      name="receiverCurrency"
      component={renderReceivableCurrency}
      receivableCurrency={receivableCurrency}
      label={new MessageFormat(worldReady, {
        id: 'buttonsV3.currency.label',
      }).format()}
      onChange={handleAmountFormatChange}
      helperText={new MessageFormat(worldReady, {
        id: 'buttonsV3.currency.helperText',
      }).format()}
    />
  );
}

Currency.propTypes = {
  receivableCurrency: PropTypes.array,
  handleAmountFormatChange: PropTypes.func,
};

renderReceivableCurrency.propTypes = {
  receivableCurrency: PropTypes.array,
};

export default Currency;
